import React from 'react';
import propTypes from 'prop-types';

const SearchIcon = props => (
  <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8542 19.1462L14.8453 14.1373C17.8153 10.7993 17.7093 5.68925 14.5093 2.48925C11.1903 -0.82975 5.80925 -0.82975 2.48925 2.48925C-0.82975 5.80825 -0.82975 11.1893 2.48925 14.5083C5.68925 17.7083 10.7992 17.8132 14.1372 14.8442L19.1462 19.8533C19.3412 20.0483 19.6582 20.0483 19.8532 19.8533C20.0482 19.6583 20.0502 19.3412 19.8542 19.1462ZM3.19725 13.8013C0.27325 10.8773 0.27325 6.12025 3.19725 3.19625C6.12125 0.27225 10.8783 0.27225 13.8022 3.19625C16.7262 6.12025 16.7262 10.8773 13.8022 13.8013C10.8792 16.7253 6.12125 16.7253 3.19725 13.8013Z" fill={props.fill} />
  </svg>

);

SearchIcon.propTypes = {
  fill: propTypes.string,
};

SearchIcon.defaultProps = {
  fill: '#727183'
};

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/assets/SearchIcon.jsx